import apiInstance from '../utils/axiosConfig';

const ServiceHDSService = {
    // Créer un service HDS avec image optionnelle
    createService: async (serviceData, mediaFile = null) => {
        try {
            const formData = new FormData();
            formData.append('serviceData', JSON.stringify(serviceData));
            if (mediaFile) {
                formData.append('mediaFile', mediaFile);
            }

            const response = await apiInstance.post('/services-hds', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error creating service HDS:', error.message || error);
            throw error;
        }
    },

    // Récupérer un service par ID
    getServiceById: async (id) => {
        try {
            const response = await apiInstance.get(`/services-hds/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching service by id:', error.message || error);
            throw error;
        }
    },

    // Récupérer tous les services
    getAllServices: async () => {
        try {
            const response = await apiInstance.get('/services-hds');
            return response.data;
        } catch (error) {
            console.error('Error fetching all services:', error.message || error);
            throw error;
        }
    },

    // Mettre à jour un service avec image optionnelle (multipart)
    updateService: async (id, serviceData, mediaFile = null) => {
        try {
            const formData = new FormData();
            formData.append('serviceData', JSON.stringify(serviceData));
            if (mediaFile) {
                formData.append('mediaFile', mediaFile);
            }

            const response = await apiInstance.put(`/services-hds/${id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error updating service:', error.message || error);
            throw error;
        }
    },

    // Mettre à jour un service sans image (JSON)
    updateServiceJson: async (id, serviceData) => {
        try {
            const response = await apiInstance.put(`/services-hds/${id}`, serviceData, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error updating service (JSON):', error.message || error);
            throw error;
        }
    },

    // Supprimer un service
    deleteService: async (id) => {
        try {
            await apiInstance.delete(`/services-hds/${id}`);
        } catch (error) {
            console.error('Error deleting service:', error.message || error);
            throw error;
        }
    },

    // Rechercher un service par nom exact
    getServiceByName: async (name) => {
        try {
            const response = await apiInstance.get(`/services-hds/search/name/${encodeURIComponent(name)}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching service by name:', error.message || error);
            throw error;
        }
    },

    // Rechercher des services par nom (contient)
    searchServicesByName: async (name) => {
        try {
            const response = await apiInstance.get('/services-hds/search', {
                params: { name }
            });
            return response.data;
        } catch (error) {
            console.error('Error searching services by name:', error.message || error);
            throw error;
        }
    },

    // === SOUS-SERVICES ===

    // Créer un sous-service
    createSubService: async (subServiceData) => {
        try {
            const response = await apiInstance.post('/services-hds/sub-services', subServiceData);
            return response.data;
        } catch (error) {
            console.error('Error creating sub-service:', error.message || error);
            throw error;
        }
    },

    // Récupérer tous les sous-services d'un service
    getSubServicesByServiceId: async (serviceId) => {
        try {
            const response = await apiInstance.get(`/services-hds/${serviceId}/sub-services`);
            return response.data;
        } catch (error) {
            console.error('Error fetching sub-services by service id:', error.message || error);
            throw error;
        }
    },

    // Mettre à jour un sous-service
    updateSubService: async (id, subServiceData) => {
        try {
            const response = await apiInstance.put(`/services-hds/sub-services/${id}`, subServiceData);
            return response.data;
        } catch (error) {
            console.error('Error updating sub-service:', error.message || error);
            throw error;
        }
    },

    // Supprimer un sous-service
    deleteSubService: async (id) => {
        try {
            await apiInstance.delete(`/services-hds/sub-services/${id}`);
        } catch (error) {
            console.error('Error deleting sub-service:', error.message || error);
            throw error;
        }
    }
};

export default ServiceHDSService;